import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowDown from "@styles/all-images/icons/arrow-down.svg";
import SearchIcon from "@styles/all-images/icons/search.svg";
import PlusIcon from "@styles/all-images/icons/plus.svg";
import ArrowLeftIcon from "@styles/all-images/icons/arrow-left.svg";
import ArrowRightIcon from "@styles/all-images/icons/arrow-right.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down.svg";
import RejectIcon from "@styles/all-images/icons/rejectIcon.svg";
import StaffAdd from "../StaffManagement/StaffAdd";
import FilterModal from "../StaffManagement/FilterModal";
import EditIcon from "@styles/all-images/icons/edit.svg";
import LockIcon from "@styles/all-images/icons/lock.svg";
import UnLockIcon from "@styles/all-images/icons/unlock.svg";
import EyeIcon from "@styles/all-images/icons/eye-blue.svg";
import DocumentIcon from "@styles/all-images/icons/document.svg";
import CheckBlueIcon from "@styles/all-images/icons/checkblue.svg";
import CloseRedIcon from "@styles/all-images/icons/closered.svg";
import StaffManagementEditCard from "../StaffManagement/StaffManagementEditCard";
import UserManagementRejectionReason from "./UserManagementRejectionReason";

interface UserManagementInvitedUserProps {
  onClose: () => void;
  onSubmit: () => void;
}

const UserManagementOnboardedUser = ({
  onClose,
  onSubmit,
}: UserManagementInvitedUserProps) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const staffData = [
    {
      userName: "John Doe",
      email: "johndoe@gmail.com",
      contactNumber: "+27 81 234 5678",
      usertype: "Tier 01 - Funders/ Credit Providers",
      status: "Onboarding Pending ",
      profiles: ["Profile 1"],
    },
    {
      userName: "Thabo Dlamini",
      email: "thabodlamini@gmail.com",
      contactNumber: "+27 82 345 6789",
      usertype: "Tier 02 - Insurance/ Guarantors",
      status: "Blitz Approval Pending ",
      profiles: ["Profile 1"],
    },
    {
      userName: "Anele Ndlovu",
      email: "anelendlovu@gmail.com",
      contactNumber: "+27 61 456 7890",
      usertype: "Tier 03 - System Management Console",
      status: "Full Onboarding Pending ",
      profiles: ["Profile 2"],
    },
    {
      userName: "Sipho Khumalo",
      email: "siphokhumalo@gmail.com",
      contactNumber: "+27 61 456 7890",
      usertype: "Tier 04 - Super Traders ",
      status: "Full Onboarding Completed ",
      profiles: ["Profile 1"],
    },
    {
      userName: "Kagiso Nkosi",
      email: "kagisonkosi@gmail.com",
      contactNumber: "+27 83 678 9012",
      usertype: "Tier 05 - Wholesale Traders",
      status: "Full Onboarding Completed ",
      profiles: ["Profile 1"],
    },
    {
      userName: "Zanele Masinga",
      email: "zanelemasinga@gmail.com",
      contactNumber: "+27 74 789 0123",
      usertype: "Tier 06 - Consultants/ Brokers",
      status: "Full Onboarding Completed ",
      profiles: ["Profile 1"],
    },
  ];

  const filteredData = staffData.filter((staff) =>
    Object.values(staff).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleOpenStaffModal = () => {
    setIsStaffModalOpen(true);
  };

  const handleOpenRejectionModal = () => {
    setIsRejectionModalOpen(true);
  };
  const handleCloseRejectionModal = () => {
    setIsRejectionModalOpen(false);
  };
  const handleRejectionSubmit = () => {
    setIsRejectionModalOpen(false);
  };

  const handleCloseStaffModal = () => {
    setIsStaffModalOpen(false);
  };

  const handleStaffSubmit = () => {
    setIsStaffModalOpen(false);
  };

  const handleOpenFilterModal = () => {
    setIsFilterModalOpen(true);
  };

  const handleClosefilterModal = () => {
    setIsFilterModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    setIsModalOpen(false);
  };

  const [isRightOpen, setIsRightOpen] = useState(false);
  const [selectedRightValue, setRightSelectedValue] = useState("5");

  const righttoggleDropdown = () => {
    setIsRightOpen(!isRightOpen);
  };

  const righthandleOptionClick = (value: string) => {
    setRightSelectedValue(value);
    setIsRightOpen(false);
  };

  return (
    <div className="tw-relative tw-bg-[#F8FAFC] custom-height-body">
      <div className="tw-p-6">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
          <div className="tw-flex tw-items-center tw-gap-4">
            <div className="tw-relative">
              <input
                type="text"
                placeholder="Search"
                className="tw-pl-10 tw-pr-4 tw-py-2 tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg tw-w-64 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <img
                src={SearchIcon}
                alt="Search Icon"
                className="tw-absolute tw-left-3 tw-top-2.5 tw-h-5 tw-w-5 tw-text-gray-400"
              />
            </div>
            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-text-sm tw-font-normal tw-text-[#809199]">
                Rows per page
              </span>
              <div className="tw-relative">
                <button
                  className="tw-flex tw-justify-between tw-items-center tw-px-3 tw-py-1 tw-bg-transparent tw-border
                   tw-border-[#E9EAEB] tw-text-[#232323] tw-rounded-lg"
                  onClick={righttoggleDropdown}
                >
                  <div className="tw-flex tw-items-center">
                    <span className="tw-mr-3 tw-font-semibold tw-text-[#535862]">
                      {selectedRightValue}
                    </span>
                  </div>
                  <div>
                    <img
                      src={ArrowDownIcon}
                      alt="Arrow Down Icon"
                      className={`tw-w-4 tw-h-4 tw-transform ${
                        isRightOpen ? "tw-rotate-180" : "tw-rotate-0"
                      }`}
                    />
                  </div>
                </button>

                {isRightOpen && (
                  <div className="tw-absolute tw-right-0 tw-w-auto tw-bg-white tw-rounded-xl tw-shadow-lg tw-border-gray-200 tw-mt-1 tw-p-3">
                    <ul className="tw-py-1">
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("1")}
                      >
                        1
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("2")}
                      >
                        2
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("3")}
                      >
                        3
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("4")}
                      >
                        4
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("5")}
                      >
                        5
                      </button>
                      <button
                        className="tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("6")}
                      >
                        6
                      </button>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-gap-4">
            <button
              onClick={handleOpenFilterModal}
              className="tw-font-semibold tw-flex-1 tw-px-4 tw-flex tw-items-center tw-py-2 tw-border font-default-primary-color tw-border-[#146C94] tw-rounded-lg tw-w-[50%] tw-text-center"
            >
              <img
                src={RejectIcon}
                alt="Plus Icon"
                className="tw-w-5 tw-h-5 tw-mr-2"
              />{" "}
              Filter
            </button>
            <button
              onClick={handleOpenStaffModal}
              className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
            >
              <img src={PlusIcon} alt="Plus Icon" className="tw-w-5 tw-h-5" />{" "}
              Add User
            </button>
          </div>
        </div>

        <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden">
          <table className="tw-w-full">
            <thead>
              <tr className="tw-border-b">
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862] tw-flex tw-items-center tw-gap-1">
                  User Name{" "}
                  <img
                    src={ArrowDown}
                    alt="Arrow Down"
                    className="tw-w-5 tw-h-5"
                  />
                </th>

                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Email
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Contact Number
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    User Type
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    status
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  Assigned Profile
                </th>

                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-gray-200">
              {currentData.map((staff, index) => (
                <tr key={index} className="tw-hover:bg-gray-50">
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {staff.userName}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {staff.email}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {staff.contactNumber}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {staff.usertype}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm">
                    <li
                      className={`tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit ${
                        staff.status === "Full Onboarding Completed "
                          ? "tw-bg-[#ECFDF3] tw-text-[#027A48]"
                          : "tw-bg-[#F5F5F5] tw-text-[#414651]"
                      }`}
                    >
                      <span
                        className={`tw-w-2 tw-h-2 tw-rounded-full ${
                          staff.status === "Full Onboarding Completed "
                            ? "tw-bg-[#12B76A]"
                            : "tw-bg-[#717680]"
                        }`}
                      ></span>
                      {staff.status}
                    </li>
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      {staff.profiles.map((profile, i) => (
                        <span
                          key={i}
                          className="tw-px-2 tw-bg-[#F8FAFC] tw-py-1 tw-border tw-border-[#E9EAEB] tw-rounded-full tw-text-sm tw-text-[#232323]"
                        >
                          {profile}
                        </span>
                      ))}
                      <span className="tw-bg-[#146C94] tw-text-white tw-text-sm tw-font-normal tw-px-2 tw-py-1 tw-rounded-full">
                        +3
                      </span>
                      <button onClick={handleOpenModal}>
                        <img
                          src={EditIcon}
                          alt="Edit Icon"
                          className="tw-w-5 tw-h-5"
                        />
                      </button>
                    </div>
                  </td>

                  <td className="tw-px-6 tw-py-3 tw-text-sm tw-flex tw-items-center tw-gap-4">
                    <button>
                      <img
                        src={LockIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                    <button>
                      <img
                        src={UnLockIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                    <button
                      onClick={() => navigate("/user-management-details")}
                    >
                      <img
                        src={EyeIcon}
                        alt="Lock Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </button>
                    <button
                      onClick={() => navigate("/approved-on-boarding-document")}
                    >
                      <img
                        src={DocumentIcon}
                        alt="Lock Icon"
                        className="tw-w-6 tw-h-6"
                      />
                    </button>
                    <button>
                      <img
                        src={CheckBlueIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                    <button onClick={handleOpenRejectionModal}>
                      <img
                        src={CloseRedIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-justify-between tw-items-center tw-mt-4">
          <div className="tw-text-sm font-gray-color">
            Page {currentPage} of {totalPages}
          </div>
          <div className="tw-flex tw-items-center tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg">
            <button
              className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tl-lg tw-rounded-bl-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <img
                src={ArrowLeftIcon}
                alt="Arrow Left Icon"
                className="tw-w-5 tw-h-5"
              />
              Previous
            </button>
            <span className="tw-bg-[#EDF3F7] tw-px-3 tw-py-1">
              {currentPage}
            </span>
            <button
              className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tr-lg tw-rounded-br-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
              <img
                src={ArrowRightIcon}
                alt="Arrow Right Icon"
                className="tw-w-5 tw-h-5"
              />
            </button>
          </div>
        </div>
        <div>
          {isModalOpen && (
            <StaffManagementEditCard
              onClose={handleCloseModal}
              onSubmit={handleSubmit}
            />
          )}
        </div>
        <div>
          {isRejectionModalOpen && (
            <UserManagementRejectionReason
              onClose={handleCloseRejectionModal}
              onSubmit={handleRejectionSubmit}
            />
          )}
        </div>
        <div
          className={`tw-fixed tw-top-0 tw-right-0 tw-h-full tw-w-full tw-bg-black/25 tw-shadow-lg tw-transition-transform tw-duration-300 tw-ease-in-out ${
            isStaffModalOpen
              ? "tw-transform tw-translate-x-0"
              : "tw-transform tw-translate-x-full"
          } tw-z-50`}
        >
          {isStaffModalOpen && (
            <StaffAdd
              onClose={handleCloseStaffModal}
              onSubmit={handleStaffSubmit}
              isStaffModalOpen={isStaffModalOpen}
            />
          )}
        </div>
        <div
          className={`tw-fixed tw-top-0 tw-right-0 tw-h-full tw-w-full tw-bg-black/25 tw-shadow-lg tw-transition-transform tw-duration-300 tw-ease-in-out ${
            isFilterModalOpen
              ? "tw-transform tw-translate-x-0"
              : "tw-transform tw-translate-x-full"
          } tw-z-50`}
        >
          {isFilterModalOpen && (
            <FilterModal
              onClose={handleClosefilterModal}
              onApply={(selectedCompanies) => {
                console.log(selectedCompanies);
                setIsFilterModalOpen(false);
              }}
              isOpen={isFilterModalOpen}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserManagementOnboardedUser;
